var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7404 40.2516H42.8496L41.825 39.2636C45.4111 35.0921 47.57 29.6764 47.57 23.785C47.57 10.6484 36.9217 0 23.785 0C10.6484 0 0 10.6484 0 23.785C0 36.9217 10.6484 47.57 23.785 47.57C29.6764 47.57 35.0921 45.4111 39.2636 41.825L40.2516 42.8496V45.7404L58.5477 64L64 58.5477L45.7404 40.2516ZM24 40C15.1467 40 8 32.8533 8 24C8 15.1467 15.1467 8 24 8C32.8533 8 40 15.1467 40 24C40 32.8533 32.8533 40 24 40Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhite);
export default __webpack_public_path__ + "static/media/searchWhite.92510b3643044ec86c9b464fbadd4866.svg";
export { ForwardRef as ReactComponent };